import React, { forwardRef } from 'react'

import { Alert, mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

import { ContactForm } from '../../../forms'
import { ContentSection } from '../../../structure'

const Title = styled.h2`
  align-self: flex-start;
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1.5rem;

  @media ${mediaQueries.mobile} {
    text-align: center;
  }
`

const ContentSectionTag = styled(ContentSection)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 27.5rem;
  width: 98%;
  padding-bottom: 6.25rem;
`

const StyledAlert = styled(Alert)`
  padding-right: 0.5rem;
  width: 100%;
  margin-bottom: 1.5rem;

  & h2 {
    font-size: 1rem;
    margin: 0;
    font-weight: 700;
  }

  & h3 {
    font-size: 0.75rem;
  }
`

interface SectionProps {
  isSubmitted?: boolean
  hasErrors?: boolean
}

export const ContactSection = forwardRef<HTMLElement, SectionProps>(
  ({ isSubmitted, hasErrors }, ref) => (
    <ContentSectionTag ref={ref} id="contact">
      <Title>Contact us</Title>
      <StyledAlert
        appearance="success"
        title="Success"
        textContent="Your message has been sent. We will respond to you as soon as possible."
        shouldShow={isSubmitted}
      />
      <StyledAlert
        appearance="error"
        title="We're sorry"
        textContent="There was an error trying to send your message. Please try again later."
        shouldShow={hasErrors}
      />
      <ContactForm from="home" />
    </ContentSectionTag>
  )
)
